<template>
  <div class="page">
    <div class="top">
      <div>
        <div class="icon"><i class="fa-regular fa-address-card"></i></div>
        <div class="title">
          Perfil <span>{{ title }}</span>
        </div>
      </div>
      <div class="actions">
        <div>
          <i class="fa-solid fa-magnifying-glass"></i>
          <input
            type="text"
            name="search"
            v-model="nick"
            @keyup.enter="getUser(nick)"
            minlength="1"
            placeholder="Pesquisar o usuário..."
          />
        </div>
      </div>
    </div>
    <div class="content" v-if="load">
      <div class="alert" v-if="alert !== ''">{{ alert }}</div>
      <div class="perfil" v-else>
        <div
          class="avatar"
          :style="{
            backgroundImage: `url('${avatarUrl(user.username, { action: '', head_direction: 3, img_format: '', dance: '', effect: '', frame_num: 30 })}')`,
          }"
        ></div>
        <div class="mission">{{ user.motto }}</div>
        <div class="info">
          Data de registro: <span>{{ user.regDate }}</span>
        </div>
        <div class="info">
          Placar de conquistas: <span>{{ user.achievementPoints }}</span>
        </div>
        <div class="info">
          É vip? <span>{{ user.isVip ? 'SIM' : 'NÃO' }}</span>
        </div>
        <!--        <div class="line">Relacionamentos:</div>-->
        <!--        <div class="rel">-->
        <!--          <div class="icon love"></div>-->
        <!--          <div-->
        <!--            class="text"-->
        <!--            @click="-->
        <!--              () => {-->
        <!--                show = true-->
        <!--                items = user.relationships.heart-->
        <!--              }-->
        <!--            "-->
        <!--          >-->
        <!--            {{ relationshipsH }} {{ relH }}-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="rel">-->
        <!--          <div class="icon friends"></div>-->
        <!--          <div-->
        <!--            class="text"-->
        <!--            @click="-->
        <!--              () => {-->
        <!--                show = true-->
        <!--                items = user.relationships.smile-->
        <!--              }-->
        <!--            "-->
        <!--          >-->
        <!--            {{ relationshipsF }} {{ relF }}-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="rel">-->
        <!--          <div class="icon dead"></div>-->
        <!--          <div-->
        <!--            class="text"-->
        <!--            @click="-->
        <!--              () => {-->
        <!--                show = true-->
        <!--                items = user.relationships.bobba-->
        <!--              }-->
        <!--            "-->
        <!--          >-->
        <!--            {{ relationshipsB }} {{ relB }}-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div class="right" v-if="alert === ''">
        <!--        <ItemBadges :item="badges" />-->
        <ItemGroups :item="groups" />
        <!--        <ItemFriends :item="friends" />-->
        <ItemRooms :item="rooms" />
      </div>
      <ModFriends v-if="show" :item="items" @close="show = !show" />
    </div>
    <div class="content" v-else>
      <span class="alert">{{ empty }}</span>
    </div>
  </div>
</template>

<script setup>

import { avatarUrl } from '@/services/api.js'
import { ref } from 'vue'

import ItemGroups from '@/components/profile-api/grupos.vue'
import ItemBadges from '@/components/profile-api/badges.vue'
import ItemFriends from '@/components/profile-api/friends.vue'
import ItemRooms from '@/components/profile-api/rooms.vue'

// Modais
import ModFriends from '@/components/profile-api/ModFriends.vue'

const title = ref('Habblet')
const nick = ref('')
const user = ref([])
const badges = ref([])
const groups = ref([])
const rooms = ref([])
const friends = ref([])
const load = ref(false)
const empty = ref('Pesquise um usuário.')
const relH = ref('')
const relF = ref('')
const relB = ref('')
const alert = ref('')
const relationshipsH = ref('')
const relationshipsB = ref('')
const relationshipsF = ref('')
const show = ref(false)
const items = ref([])

function getUser(userTemp) {
  load.value = false
  empty.value = userTemp === '' ? 'Pesquise um usuário.' : 'Carregando...'
  user.value = []
  badges.value = []
  groups.value = []
  rooms.value = []
  friends.value = []
  relationshipsH.value = ''
  relationshipsB.value = ''
  relationshipsF.value = ''
  relH.value = ''
  relF.value = ''
  relB.value = ''

  if (userTemp !== '') {
    axios
      .get('https://api.habblet.city/player/' + userTemp)
      .then((req) => {
        alert.value = req.data?.text ?? ''
        user.value = req.data
        title.value = 'de ' + req.data?.username

        axios
          .get('https://api.habblet.city/player/' + req.data?.id + '/groups')
          .then((req) => {
            groups.value = req.data ?? []
          })
          .catch(() => {
            groups.value = []
          })

        axios
          .get('https://api.habblet.city/player/' + req.data?.id + '/rooms')
          .then((req) => {
            rooms.value = req.data ?? []
          })
          .catch(() => {
            rooms.value = []
          })

        // if (req.data?.user?.relationships?.heart) {
        //   relationshipsH.value = req.data?.user?.relationships?.heart?.length > 0 ? req.data?.user?.relationships?.heart[0].username : ''
        //   relH.value = req.data?.user?.relationships?.heart?.length > 1 ? 'e ' + (req.data?.user?.relationships?.heart.length - 1) + ' outros' : ''
        // }
        //
        // if (req.data?.user?.relationships?.smile) {
        //   relationshipsF.value = req.data?.user?.relationships?.smile?.length > 0 ? req.data?.user?.relationships?.smile[0].username : ''
        //   relF.value = req.data?.user?.relationships?.smile?.length > 1 ? 'e ' + (req.data?.user?.relationships?.smile.length - 1) + ' outros' : ''
        // }
        //
        // if (req.data?.user?.relationships?.bobba) {
        //   relationshipsB.value = req.data?.user?.relationships?.bobba?.length > 0 ? req.data?.user?.relationships?.bobba[0].username : ''
        //   relB.value = req.data?.user?.relationships?.bobba?.length > 1 ? 'e ' + (req.data?.user?.relationships?.bobba.length - 1) + ' outros' : ''
        // }
      })
      .finally(() => {
        load.value = true
      })
  } else {
    title.value = 'Habblet'
  }
}
</script>

<style scoped>
.page {
  margin-top: 30px;
}

.page .top {
  width: 100%;
  height: 34px;
  display: flex;
  justify-content: space-between;
  /*
    display: flex;
      width: 100%;
      height: 50px;
      line-height: 50px;
      color: #fff;
      border-radius: 12px 12px 0 0;
      background-color: var(--color2);
      padding-left: 20px;
      font-size: 13px;
      font-weight: 600;
    justify-content: space-between; */
}

.page .top .icon {
  background-image: none;
  background-color: #21415c;
}

/* .page .top .title {width: 30%;} */

.page .top .actions {
  position: relative;
  width: 28%;
}

.page .top .actions div {
  width: 100%;
}

.page .top .actions div > i {
  position: absolute;
  margin: 12px 0 0 14px;
  font-size: 13px;
}

.page .top .actions div > input {
  float: left;
  width: 220px;
  height: 36px;
  background-color: #fff;
  border-radius: 20px;
  padding-left: 36px;
}

.page .content {
  /* width: 100%;
  height: auto;
  background-color: #fff;
  padding: 0;
  font-size: 13px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.15); */
}

.page .content .alert {
  width: 100%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
}

.page .content .perfil {
  width: 100%;
  padding: 10px;
}

.page .content .right {
  position: relative;
  width: 100%;
  padding: 10px;
}

.page .content .avatar {
  float: left;
  width: 140px;
  height: 200px;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  margin-top: 10px;
}

.page .content .mission {
  float: left;
  width: calc(100% - 150px);
  height: auto;
  border-radius: 4px;
  margin: 10px 0 0 10px;
  text-align: center;
  line-height: 20px;
  padding: 10px 0;
  font-size: 13px;
}

.page .content .perfil .info,
.page .content .mission {
  background-color: #f1f1f1;
  border-radius: 12px;
}

.page .content .perfil .info span,
.page .content .mission span {
  font-weight: 500;
}

.page .content .perfil .line {
  float: left;
  position: relative;
  width: calc(100% - 150px);
  height: 30px;
  top: 10px;
  left: 10px;
  font-size: 14px;
  font-weight: 600;
}

.page .content .perfil .info {
  float: left;
  width: calc(100% - 150px);
  height: auto;
  margin: 6px 0 0 10px;
  text-align: center;
  line-height: 20px;
  padding: 10px 0;
  font-size: 13px;
}

.page .content .perfil .rel {
  float: left;
  width: calc(100% / 3 - 60px);
  height: 30px;
  font-size: 13px;
  font-weight: 500;
  margin-left: 6px;
}

.page .content .perfil .rel:first-of-type {
  margin-top: 4px;
}

.page .content .perfil .rel .icon {
  float: left;
  width: 20px;
  height: 20px;
  background-position: center;
  background-repeat: no-repeat;
  margin: 5px 0 0 0;
}

.page .content .perfil .rel .icon.love {
  background-image: url('@/assets/icon1.png');
}

.page .content .perfil .rel .icon.dead {
  background-image: url('@/assets/icon2.png');
}

.page .content .perfil .rel .icon.friends {
  background-image: url('@/assets/icon3.png');
}

.page .content .perfil .rel .text {
  float: left;
  width: calc(100% - 45px);
  height: 20px;
  line-height: 20px;
  text-align: left;
  margin: 4px 0 0 10px;
}

.page .content .right .box {
  width: 100%;
  position: relative;
  margin-bottom: 16px;
}

.page .content .right .box .top {
  height: 50px;
}

.page .content .right .box .top button {
  width: auto;
  height: 36px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ccc;
  margin: 7px 7px 0 0;
  color: #444;
  font-size: 13px;
  font-weight: 500;
  padding: 0 10px;
  transition: all 0.3s ease;
  cursor: pointer;
}

/*noinspection ALL*/
.page .content .right .box .top button:hover {
  background-color: var(--color2);
  color: #fff;
  border-color: #fff;
}

.page .content .right .box .content {
  position: relative;
  width: 100%;
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: space-around;
  flex-flow: wrap;
  box-shadow: none;
  border: 1px solid #ccc;
  border-top: 0;
}
</style>
